<template>
    <div class="o-videoshop-grid">
        <OVideoShopGridItem 
            v-for="movie in preparedItems"
            :key="movie.MovieID"
            :title="movie.Title"
            :poster="movie.PosterUrl"
            :movie-id="movie.MovieID"
            :cinema-id="cinemaId"
        />
    </div>
</template>

<script>

import { mapState} from "vuex";

import OVideoShopGridItem from '../../organisms/o-videoshop-grid-item';

export default {
    name: "OVideoShopGrid",
    components: {
        OVideoShopGridItem
    },
    data() {
        return {
            cinemaId: Number(this.$route.query.cinemaId)
        }
    },
    computed: {
        ...mapState({
            moviesList: state => state.moviesList
        }),
        preparedItems() {
            return this.moviesList.length
                ? this.moviesList
                : new Array(10).fill({title: '', poster: '', movieId: 0});
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />